<template>
  <v-container
    class="message-bar-container"
    v-bind:style="{width: resultsContainerWidth-resultsSectionSourceCarouselWidth + 'px'}"
  >
    <span class="notch notch-bot-right"></span>
    <span class="notch notch-bot-left"></span>
    <v-layout v-if="problemsStateOpen" class="message-bar-messages-container">
      <span v-if="!hasProblemMessages" class="message-bar-messages-empty">
        {{ $t('messageBar.noErrorMessages') }}
      </span>
      <div v-else>
        <CanvasProblems></CanvasProblems>
      </div>
    </v-layout>
    <v-layout v-else-if="queryTranslationsOpen" class="message-bar-messages-container">
      <span v-if="!showPolyglotQueries" class="message-bar-messages-empty">
        {{ $t('messageBar.noPolyglotQueriesErrors') }}
      </span>
      <PolyglotQueries v-else :query="polyglotString"></PolyglotQueries>
    </v-layout>
    <v-layout row class="message-bar-btn-container">
      <MessageBarBtn
        :handleOnClick="handleProblemsClick"
        :btnTitle="$t('messageBar.btnLabel.problems')"
        :show-text="showTextCondition"
        defaultIcon="done"
        secondaryIcon="warning"
        :iconCondition="!hasProblemMessages"
        dividerPosition="right"
        :btnSelected="problemsStateOpen"
      ></MessageBarBtn>
      <MessageBarBtn
        :handleOnClick="handleQueryTranslationClick"
        :btnTitle="$t('messageBar.btnLabel.translations')"
        :show-text="showTextCondition"
        defaultIcon="manage_search"
        dividerPosition="right"
        :btnSelected="queryTranslationsOpen"
      ></MessageBarBtn>
      <v-flex grow></v-flex>
      <MessageBarBtn
        :handleOnClick="handleAiClick"
        :btnTitle="$t('misc.ai.title')"
        :show-text="showTextCondition"
        defaultIcon="rebase_edit"
        dividerPosition="both"
      ></MessageBarBtn>
    </v-layout>
  </v-container>
</template>

<script>
import '../../../style/_variables.scss'
import {resultsSectionSourceCarouselWidth} from '../../../utils/constants'
import PolyglotQueries from '../PolyglotQueries.vue'
import {
  MessageBarBtn,
  CanvasProblems
} from './index'

export default {
  name: 'ResultsSectionMessageBar',
  components: {
    PolyglotQueries, MessageBarBtn, CanvasProblems
  },
  props: ['showPolyglotQueries'],
  data () {
    return {
      resultsSectionSourceCarouselWidth: resultsSectionSourceCarouselWidth,
      showTextCondition: true
    }
  },
  computed: {
    queryMessages: { get () { return this.$store.state.queryState.queryMessage } },
    resultsContainerWidth: { get () { return this.$store.state.appState.resultsContainerWidth } },
    polyglotString: { get () { return this.$store.state.queryState.polyglotString } },
    hasProblemMessages: { get () { return this.queryMessages.length > 0 } },
    queryTranslationsOpen: { get () { return this.$store.getters.getShowQueryTranslations } },
    problemsStateOpen: { get () { return this.$store.getters.getShowQueryProblemMessages } }
  },
  watch: {
    resultsContainerWidth (val) {
      this.showTextCondition = val - 70 > 585
    }
  },
  methods: {
    handleProblemsClick () {
      this.$store.commit('setHandleProblemsClick')
    },
    handleQueryTranslationClick () {
      this.$store.commit('setHandleQueryTranslationsClick')
      this.showPolyglotQueries = true
    },
    handleAiClick () {
      this.$store.dispatch('handleSearchAIClick')
    }
  }
}
</script>

<style lang="scss" scoped>
.message-bar {
  &-container {
    position: absolute;
    bottom: 0;
    right: 0;
    padding: 5px 0;
    background-color: $grey-400;
    max-width: calc(100vw - #{$side-nav-width} - #{$side-nav-width} - 20px);
  }
  &-btn {
    &-container {
      margin-left: 10px;
      margin-right: 145px;
    }
  }
  &-messages {
    &-container {
      background-color: $bg-primary;
      padding: 2px 15px;
      border-radius: 10px;
      margin-bottom: 5px;
      margin-top: 2px;
      max-height: 400px;
      overflow: hidden;
      z-index: 21;
      position: relative;
    }
    &-empty {
      font-style: italic;
    }
  }
}
.notch {
  position: absolute;
  width: 25px;
  aspect-ratio: 1;
  background: $grey-400;
  z-index: 1;
  // @todo - this is best way to create the outer of a quater circle shape
  --mask: radial-gradient(25px at 0 100%,#0000 98%,#000);
  -webkit-mask: var(--mask);
  mask: var(--mask);
  &-bot-left {
    top: -24px;
    left: 0;
    transform: rotate(180deg);
  }
  &-bot-right {
    top: -24px;
    right: 0;
    transform: rotate(90deg);
  }
}
</style>



// WEBPACK FOOTER //
// src/components/parts/ResultsContainer/ResultsSectionMessageBar.vue